import {applyMiddleware, compose, createStore} from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './rootReducer';
import rootSaga from './saga';

    declare global {

        interface Window {
            __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
        }
    }

    // // @ts-ignore
    // const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


// Function to save specific state slice to localStorage
function saveStateSliceToLocalStorage(name: string, stateSlice: any) {
    try {
        const serializedState = JSON.stringify(stateSlice);
        localStorage.setItem(`ai_${name}`, serializedState);
    } catch (e) {
        console.error("Could not save state slice", e);
    }
}

// Function to load the specific slice of the state from localStorage
function loadStateSliceFromLocalStorage(name: string) {
    try {
        const serializedState = localStorage.getItem(`ai_${name}`);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (e) {
        console.error("Could not load state slice", e);
        return undefined;
    }
}

const sagaMiddleware = createSagaMiddleware();
let _store;
const preloadedState = {
    Ingredients: loadStateSliceFromLocalStorage('ingredients'), // Load just the user slice from localStorage
};
if(process.env.NODE_ENV === 'production'){
    _store = createStore(
        rootReducer,
        preloadedState,
        compose(
            applyMiddleware(sagaMiddleware)
        )
    )
}else{
    _store = createStore(
        rootReducer,
        preloadedState,
        compose(
            applyMiddleware(sagaMiddleware),
            // (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
            typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "undefined" ? (a:any) => a : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
        )
    )
}
const store = _store

// Subscribe to store changes, but only act if the `user` slice changes
store.subscribe(() => {
    const currentUserState = store.getState().Ingredients;
    saveStateSliceToLocalStorage('ingredients', currentUserState);
});

sagaMiddleware.run(rootSaga);

export default store;
